import styled from 'styled-components';
import { Modal } from '@material-ui/core';
const ModalStyled = styled(Modal)`
  .add-or-edt {
    /* border-radius: 5px; */
    border-radius: ${(props) => (props.isHasBcg ? '5px' : '10px')};
    padding: 0;
    .modal-title {
      padding-left: 24px;
      line-height: 60px;
      font-size: 18px;
      /* font-weight: 700; */
      /* background-color: #f5f5f5; */
      /* 更改样式 */
      background: ${(props) => (props.isHasBcg ? '#1565c0' : '#fff')};
      color: ${(props) => (props.isHasBcg ? '#ffffff' : '#000000')};
      border-radius: ${(props) => (props.isHasBcg ? '' : '10px')};
      padding-right: 35px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .close {
        display: flex;
        align-items: center;
        svg {
          cursor: pointer;
          width: 13px;
          height: 13px;
        }
      }
    }
    .cardContent {
      padding: 24px 0 0;
    }
    .buttonWrap {
      padding: 40px ${(props) => props.theme.spacing(3)};
      display: flex;
      justify-content: center;
      align-items: center;
      .secondary {
        margin-left: 16px;
        margin-right: 16px;
        box-shadow: 0 0 0;
        border: 1px solid #333;
      }
    }
    .dd {
      width: 275px;
    }
    .cc {
      width: 275px;
    }
    .cc-margin {
      margin: 20px 0 40px;
    }
    .add-hospital-code-input {
      margin-bottom: 40px;
    }
  }
  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export default ModalStyled;
